import { render, staticRenderFns } from "./InventoryBySerial.vue?vue&type=template&id=81729552&"
import script from "./InventoryBySerial.vue?vue&type=script&lang=js&"
export * from "./InventoryBySerial.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBySerial.vue?vue&type=style&index=0&id=81729552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports